export interface FaqItem {
  question: string;
  answer: string;
}

export const faqList: FaqItem[] = [
  {
    question: "爆点观察局的热度数据是怎么统计出来的？",
    answer:
      "我们把公开可见的搜索、讨论、转发、二创等维度加权合成一个综合热度值，用于横向比较话题的受关注程度。热度值反映注意力规模，不代表事件真伪。",
  },
  {
    question: "热度值和转发量分别代表什么？",
    answer:
      "热度值衡量话题的综合受关注程度，转发量只统计被分享扩散的次数。一个话题可能转发量很高但热度一般，也可能讨论很多但转发集中在少数平台。",
  },
  {
    question: "为什么话题里的人物都做了匿名处理？",
    answer:
      "我们只观察话题如何被传播，不针对具体个人做事实判断。对所有涉及个人身份的信息进行匿名化，既是内容原则，也是对传播中可能存在的不实信息的谨慎处理。",
  },
  {
    question: "榜单多久更新一次？",
    answer:
      "榜单分为实时与复盘两部分：实时榜单随话题热度变化滚动刷新，复盘榜单在话题热度回落后整理其完整扩散轨迹，通常保留 7 天。",
  },
  {
    question: "我可以投稿或者纠正某条信息吗？",
    answer:
      "可以。如果你发现某条话题的素材层级标注有误，或想提供新的观察线索，欢迎通过订阅表单留下联系方式与说明，我们会在核实后更新对应的扩散记录。",
  },
];

export const siteStats = [
  { label: "累计追踪话题", value: "12,846", unit: "条" },
  { label: "单日最高转发", value: "486", unit: "万次" },
  { label: "平均出圈耗时", value: "19", unit: "小时" },
  { label: "覆盖内容平台", value: "18", unit: "个" },
];